import React__default, { forwardRef } from 'react';
import { toAlignmentAttributes } from './Alignment/alignment.js';
import { toSpacingAttributes } from './Spacing/spacing.js';
import './Group.scss';

const Group = forwardRef(({ children, className, ariaLabel, id, itemsSpacing = 4, margin, padding, itemsAlignX = 'space-between', itemsAlignY = 'center', noWrap = false, isScrollable, isPositionContainer, }, ref) => {
    return (React__default.createElement("div", { ref: ref, "data-rev-component": 'group', className: className, "aria-label": ariaLabel, id: id, "data-rev-no-wrap": noWrap ? 'true' : 'false', "data-rev-scrollable": isScrollable, "data-rev-position-container": isPositionContainer, ...toSpacingAttributes('m', margin), ...toSpacingAttributes('p', padding), ...toSpacingAttributes('g', itemsSpacing), ...toAlignmentAttributes('x', itemsAlignX), ...toAlignmentAttributes('y', itemsAlignY) }, children));
});
Group.displayName = 'Group';
const GroupItem = ({ className, ariaLabel, grow, children }) => {
    const flexGrow = grow === true ? 1 : typeof grow === 'number' ? grow : undefined;
    return (React__default.createElement("div", { "data-rev-component": 'group-item', className: className, "aria-label": ariaLabel, "data-rev-grow": flexGrow }, children));
};
Group.Item = GroupItem;

export { Group };
//# sourceMappingURL=Group.js.map
